import classNames from 'classnames';
import {
  BaseSyntheticEvent,
  useRef,
  useState
} from 'react';
import uuid from 'react-uuid';
import Button from '../../Atoms/Button';
import Icon from '../../Atoms/Icon';
import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';

type Props = {
  theme?: 'dark' | 'light';
};

function FormFile({ theme = 'dark' }: Props) {
  const [fileName, setFileName] = useState<string | null>(
    null
  );

  const inputRef = useRef<HTMLInputElement | null>(null);

  const inputID = uuid();

  const fileUploadedBg =
    theme === 'light' ? 'bg-sl-indigo' : 'bg-sl-blue';

  const handleChange = (e: BaseSyntheticEvent) => {
    if (e.target?.files)
      setFileName(e.target?.files[0].name);
  };

  const handleClick = (e: BaseSyntheticEvent) => {
    if (fileName && inputRef.current) {
      e.preventDefault();
      inputRef.current.value = '';
      setFileName(null);
    }
  };

  return (
    <form
      action="#!"
      className="overflow-hidden rounded-xl @container"
    >
      <label
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        className="relative z-[10]"
        htmlFor={inputID}
      >
        <div
          className={classNames([
            'relative flex w-full cursor-pointer items-center overflow-hidden rounded-xl py-8 px-6 transition-colors duration-300 @sm:py-12 @sm:px-7',
            fileName ? fileUploadedBg : 'bg-sl-yellow'
          ])}
        >
          <input
            ref={inputRef}
            type="file"
            name="file"
            id={inputID}
            multiple={false}
            className="hidden"
            accept=".pdf, .doc, .docx, .txt, .rtf"
            onClick={fileName ? handleClick : undefined}
            onChange={!fileName ? handleChange : undefined}
          />
          <div className="mr-3 inline-flex h-12 shrink-0 basis-12 items-center justify-center rounded-full bg-white text-xl text-sl-blue shadow-lg xsm:mr-5">
            {!fileName ? (
              <Icon icon="plus" />
            ) : (
              <Icon icon="minus" />
            )}
          </div>
          <div>
            <Title as="h5">
              <span
                className={`transtion-color duration-300 ${
                  !fileName ? 'text-sl-blue' : 'text-white'
                }`}
              >
                Upload je CV
              </span>
            </Title>
            <Text size="sm" as="p" font="circular">
              <span
                className={`transtion-color !leading-tight duration-300 ${
                  !fileName
                    ? 'text-sl-blue-dark opacity-50'
                    : 'text-white'
                }`}
              >
                {!fileName ? (
                  <span>Binnen 1 uur reactie</span>
                ) : (
                  <span>{fileName}</span>
                )}
              </span>
            </Text>
          </div>
        </div>
      </label>
      <div className="relative -top-3 z-[1] rounded-b-xl bg-white p-6 pt-9 @sm:p-7 @sm:pt-10">
        <div className="flex items-center justify-between">
          <a
            href="#!"
            className="mr-3 text-sm text-sl-blue underline hover:no-underline"
          >
            Als je op verstuur klikt, ga je akkoord met de
            voorwaarden
          </a>
          <Button
            shadow
            text="Verstuur"
            color="secondary"
            type="submit"
          />
        </div>
      </div>
    </form>
  );
}

export default FormFile;
